module.exports = __webpack_public_path__ + "img/icon-ai-similar-blue.b34c3f6d.svg";